import { AddRounded } from '@mui/icons-material';
import styled from 'styled-components';

interface AddButtonProps {
		onClick: () => void;
}

const AddButtonStyle = styled.div`
	height: 40px;
	width: 40px;
	border-radius: 50%;
	border: .15rem solid #8fa202;
	color: #8fa202;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.5rem;
	cursor: pointer;
	&:hover {
		border-color: #9db104;
		color: #9db104;
	}
`;

export default function AddButton(props: AddButtonProps) {
		return <AddButtonStyle {...props}>
				<AddRounded />
		</AddButtonStyle>
}